export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_49-3c5e51ead76d541d04b6947f4f56191e.jpg";